import { render } from "./QuestionDisplay.vue?vue&type=template&id=6d593c2a"
import script from "./QuestionDisplay.vue?vue&type=script&lang=js"
export * from "./QuestionDisplay.vue?vue&type=script&lang=js"

import "./QuestionDisplay.vue?vue&type=style&index=0&id=6d593c2a&lang=css"

import exportComponent from "/Users/sahanakumari/Documents/GitHub/zsurvey-app/zsurvey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__